module.exports = "/_next/static/images/headphones-98d7ae6021e3e2189791e26ddc1b3ef3.svg";